import { CuffaMeasurementUnitEnum } from 'common/enums';

export interface ProdutoSelecionadoLite {
    uuid: string;
    name: string;
    selecionado?: boolean;
    expandido?: boolean;
    production_area_hectares?: number | null;
    volume_produced?: number | null;
    volume_produced_unit?: CuffaMeasurementUnitEnum;
    volume_commercialized?: number | null;
    volume_commercialized_unit?: CuffaMeasurementUnitEnum;
    average_commercialized_value?: number | null;
    volume_self_consumption?: number | null;
    volume_self_consumption_unit?: CuffaMeasurementUnitEnum;
    volume_lost?: number | null;
    volume_lost_unit?: CuffaMeasurementUnitEnum;
    is_processed?: boolean;
    production_type?: any;
    product_type?: any;
    availability_months?: Record<string, any>;
}

export const updateProdutosField = (
    produtos: ProdutoSelecionadoLite[],
    uuidParam: string,
    campo: string,
    valor: any,
) => produtos.map(p => {
    if (p.uuid !== uuidParam) return p;

    if (campo.startsWith('availability_months.')) {
        const subCampo = campo.split('.')[1];
        return {
            ...p,
            availability_months: {
                ...(p.availability_months ?? {}),
                [subCampo]: valor,
            }
        };
    }

    return { ...p, [campo]: valor } as ProdutoSelecionadoLite;
});

export const buildProducaoApiData = (
    praticaAgroecologica: boolean | null,
    certificacoes: string[],
    otherCertifications: Array<{ description: string }>,
    produtos: ProdutoSelecionadoLite[],
    certificationMap: Record<string, string>,
) => {
    const apiData: any = {
        practices_agroecological_organic: praticaAgroecologica,
        certification_types: [],
        other_certifications: [],
        conventional_products: [],
    };

    if (praticaAgroecologica) {
        apiData.certification_types = [
            ...certificacoes.filter(c => c !== 'OUTRO').map(c => certificationMap[c]),
            ...(otherCertifications.length > 0 ? ['OUTRO'] : []),
        ];
        apiData.other_certifications = otherCertifications;

        apiData.conventional_products = produtos
            .filter(p => p.selecionado)
            .map(p => ({
                product_id: p.uuid,
                name: p.name,
                production_area_hectares: p.production_area_hectares,
                volume_produced: p.volume_produced,
                volume_produced_unit: p.volume_produced_unit,
                volume_commercialized: p.volume_commercialized,
                volume_commercialized_unit: p.volume_commercialized_unit,
                average_commercialized_value: p.average_commercialized_value,
                volume_self_consumption: p.volume_self_consumption,
                volume_self_consumption_unit: p.volume_self_consumption_unit,
                volume_lost: p.volume_lost,
                volume_lost_unit: p.volume_lost_unit,
                availability_months: p.availability_months,
            }));
    }

    return apiData;
};

export default {};
